import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'
import OverviewPage from './components/OverviewPage'
import { sendStaffAppMetaData } from '../../staffApp/eventTriggers';

export default function DischargeModal(props) {
  const dispatch = useDispatch();
  const { ui, resident, config, organization } = useSelector(state=>state);
  const { occupancy, show, action  } = ui.dischargeModal;
  const closeModal = () => dispatch({ type: "CLOSE_DISCHARGE_OCCUPANCY_MODAL" });
  const tabDefaultMetaData =  useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'current_occupancies'))
  const [ currentPage, setCurrentPage ] = useState(0);
  const pages = [<OverviewPage onClose={closeModal}/>, ]

  let closeDischargeFormFunction = (e) => {
    closeModal()
    sendStaffAppMetaData(tabDefaultMetaData)
  }

  React.useEffect(()=>{
    document.addEventListener(`closeDischargeForm`, closeDischargeFormFunction)

    return () => document.removeEventListener(`closeDischargeForm`, closeDischargeFormFunction)
  },[])

  return (
    <Modal show={show} onHide={closeModal}>
      {
        !config.isStaffApp &&
        <Modal.Header closeButton>
          <Modal.Title>Discharge</Modal.Title>
        </Modal.Header>
      }
      <Modal.Body>
        {pages[currentPage]}
      </Modal.Body>
    </Modal>
  )
}
